const CountDisplay = ({ x, y }) => {
    return (
      <div className=" p-2 border rounded-md shadow-md max-w-sm mx-auto flex gap-2 justify-center items-center ">
        <p className=" font-semibold ">Slots filled</p>
        <p className="text-gray-700">
          <span className="font-bold">{x}</span> /
          <span className="font-bold"> {y}</span>
        </p>
      </div>
    );
  };
  
  export default CountDisplay;
  